"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Proposal_connector;
Object.defineProperty(exports, "__esModule", { value: true });
const connect_core_1 = require("@1hive/connect-core");
class Proposal {
    /**
     * Create a new Proposal instance.
     * @param data The proposal data.
     * @param connector A GardenConnector instance.
     */
    constructor(data, connector) {
        _Proposal_connector.set(this, void 0);
        __classPrivateFieldSet(this, _Proposal_connector, connector, "f");
        this.id = data.id;
        this.organization = data.organization;
        this.number = data.number;
        this.creator = data.creator;
        this.status = data.status;
        this.type = data.type;
        this.createdAt = data.createdAt;
        this.executedAt = data.executedAt;
        this.metadata = data.metadata;
        this.txHash = data.txHash;
        // proposal data
        this.link = data.link;
        this.stakes = data.stakes;
        this.stakesHistory = data.stakesHistory;
        this.beneficiary = data.beneficiary;
        this.requestedAmount = data.requestedAmount;
        this.totalTokensStaked = data.totalTokensStaked;
        this.stable = data.stable;
        //voting data
        this.setting = data.setting;
        this.startDate = data.startDate;
        this.totalPower = data.totalPower;
        this.snapshotBlock = data.snapshotBlock;
        this.yeas = data.yeas;
        this.nays = data.nays;
        this.quietEndingExtensionDuration = data.quietEndingExtensionDuration;
        this.quietEndingSnapshotSupport = data.quietEndingSnapshotSupport;
        this.script = data.script;
        this.isAccepted = data.isAccepted;
        this.casts = data.castVotes;
        //dispute data
        this.actionId = data.actionId;
        this.challengeId = data.challengeId;
        this.challenger = data.challenger;
        this.challengeEndDate = data.challengeEndDate;
        this.disputeId = data.disputeId;
        this.settledAt = data.settledAt;
        this.settlementOffer = data.settlementOffer;
        this.disputedAt = data.disputedAt;
        this.pausedAt = data.pausedAt;
        this.pauseDuration = data.pauseDuration;
        this.submitterArbitratorFeeId = data.submitterArbitratorFeeId;
        this.challengerArbitratorFeeId = data.challengerArbitratorFeeId;
    }
    /**
     * Close the connection.
     */
    async disconnect() {
        await __classPrivateFieldGet(this, _Proposal_connector, "f").disconnect();
    }
    /**
     * Fetch the collateral requirement of the proposal.
     * @returns A promise that resolves to the collateral requirement of the proposal.
     */
    async collateralRequirement() {
        return __classPrivateFieldGet(this, _Proposal_connector, "f").collateralRequirement(this.id);
    }
    /**
     * Subscribe to updates in the collateral requirement of the proposal.
     * @param callback A function callback to postprocess the result.
     * @returns A GraphQL subsription to the collateral requirement of the proposal.
     */
    onCollateralRequirement(callback) {
        return (0, connect_core_1.subscription)(callback, (callback) => __classPrivateFieldGet(this, _Proposal_connector, "f").onCollateralRequirement(this.id, callback));
    }
    /**
     * Fetch the arbitrator fee for the submitter of the proposal.
     * @returns A promise that resolves to the arbitrator fee for the submitter of the proposal.
     */
    async submitterArbitratorFee() {
        return __classPrivateFieldGet(this, _Proposal_connector, "f").arbitratorFee(this.submitterArbitratorFeeId || '');
    }
    /**
     * Subscribe to updates in the arbitrator fee for the submitter of the proposal.
     * @param callback A function callback to postprocess the result.
     * @returns A GraphQL subsription to the arbitrator fee for the submitter of the proposal.
     */
    onSubmitterArbitratorFee(callback) {
        return (0, connect_core_1.subscription)(callback, (callback) => __classPrivateFieldGet(this, _Proposal_connector, "f").onArbitratorFee(this.submitterArbitratorFeeId || '', callback));
    }
    /**
     * Fetch the arbitrator fee for the challenger of the proposal.
     * @returns A promise that resolves to the arbitrator fee for the challenger of the proposal.
     */
    async challengerArbitratorFee() {
        return __classPrivateFieldGet(this, _Proposal_connector, "f").arbitratorFee(this.challengerArbitratorFeeId || '');
    }
    /**
     * Subscribe to updates in the arbitrator fee for the challenger of the proposal.
     * @param callback A function callback to postprocess the result.
     * @returns A GraphQL subsription to the arbitrator fee for the challenger of the proposal.
     */
    onChallengerArbitratorFee(callback) {
        return (0, connect_core_1.subscription)(callback, (callback) => __classPrivateFieldGet(this, _Proposal_connector, "f").onArbitratorFee(this.challengerArbitratorFeeId || '', callback));
    }
}
exports.default = Proposal;
_Proposal_connector = new WeakMap();
